import { ref } from 'vue'
import { useDevLogger } from '@/composables/dev-logger/index.ts'
import { debounce } from '@/lib/helpers.js'

let instance = null

const height = ref(window.innerHeight)
const width = ref(window.innerWidth)

const logger = useDevLogger('resize-listener')

const onResize = debounce(({ target: { innerWidth, innerHeight } }) => {
  width.value = innerWidth
  height.value = innerHeight
}, 500)

export const createWindowResizeListener = () => {
  if (instance) return logger.error('There is existing instance of resize-listener')

  onResize({ target: window })
  window.addEventListener('resize', onResize)
  instance = true

  return instance
}

export const destroyWindowResizeListener = () => {
  window.removeEventListener('resize', onResize)
  instance = null

  return instance
}

export const useWindowResizeListener = () => {
  return {
    width,
    height,
  }
}
